import { buttonProviderFactory, TextInputProvider } from "../base/controlProvider";
export class LocalCustomSelect {
    constructor(nativeSelect) {
        this.nativeSelect = nativeSelect;
        this.nativeSelect.addClass("hidden");
    }
    getOptions() {
        const textInput = this.nativeSelect.data("custom-select-text-input");
        const items = this.nativeSelect
            .find("option")
            .toArray()
            .map((o) => {
            const option = $(o);
            const value = option.prop("value");
            return {
                displayName: option.html().trim(),
                value: value === "" ? undefined : value,
                selected: !!option.prop("selected"),
                groupLabel: option.parent("optgroup").prop("label"),
            };
        });
        return {
            container: this.nativeSelect.parent(),
            showSearch: this.nativeSelect.is("[data-show-search='true']"),
            disabled: this.nativeSelect.prop("disabled"),
            name: this.nativeSelect.prop("name"),
            hidden: this.nativeSelect.data("custom-select-hidden"),
            items,
            controlProvider: textInput ? new TextInputProvider() : buttonProviderFactory.make(),
            label: $(`label[for='${this.nativeSelect.prop("id")}']`),
        };
    }
    addItems(...items) {
        items.forEach((i) => this.nativeSelect.append($("<option>", {
            value: i.value,
            text: i.displayName,
            selected: i.selected,
        })));
    }
    removeItems(...items) {
        items.forEach((i) => {
            const value = i.value === undefined ? "" : i.value;
            this.nativeSelect
                .find("option")
                .filter((_, o) => $(o).val() === value)
                .remove();
        });
    }
    enable() {
        this.nativeSelect.prop("disabled", false);
    }
    disable() {
        this.nativeSelect.prop("disabled", true);
    }
}
